package io.horion.cv.styles

import androidx.compose.animation.core.Ease
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderRight
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Colors.borders
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val CoverJobStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.LighterBlue.copy(alpha = 10))
            .border(1.px, LineStyle.Solid, Colors.LighterBlue.copy(alpha = 5))

    }
    hover{
        Modifier
            .backgroundColor(Colors.LighterBlue.copy(alpha = 5))
            .border(1.px, LineStyle.Solid, Colors.LighterBlue.copy(alpha = 5))
            .scale(1.04)
            .transition(Transition.of(property = TransitionProperty.All, duration = 200.ms))

    }
}

val InteractiveElementStyle = CssStyle {
    base {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.border)
            .boxShadow(color = Color.transparent)
            .transition {
                property("shadow")
                duration(300.ms)
                property("transform")
                duration(300.ms)
            }
            .transition {
                property("all")
                duration(200.ms)
            }
    }

    hover {
        Modifier
            .border(1.px, LineStyle.Solid, Colors.Black)
            .scale(1.01)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 6.px,
                spreadRadius = 3.px,
                color = rgba(0, 1, 6, 0.1)
            )
    }
}

val FormlocalisationStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(40.px)
            .backgroundColor(Colors.HalfWhite)
            .color(Colors.Black)
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .borderRadius(12.px)
            .padding(left = 10.px, right = 20.px)
            .fontSize(16.px)
            .transition {
                property("border-color")
                duration(200.ms)
            }
    }
    hover{
        Modifier
            .border(1.px, LineStyle.Solid, Colors.Black)

    }
}
val TextFormFieldWhiteStyle = CssStyle {
    base{
        Modifier
            .fillMaxWidth()
            .height(40.px)
            .backgroundColor(Colors.HalfWhite)
            .color(Colors.Black)
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .padding(left = 10.px, right = 20.px)
            .fontSize(16.px)
            .transition {
                property("border-color")
                duration(200.ms)
            }
    }
    hover{
        Modifier
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 6.px,
                spreadRadius = 3.px,
                color = rgba(0, 1, 6, 0.1)
            )
    }
}
val SelectFormInputStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(40.px)
            .backgroundColor(Colors.White)
            .color(Colors.Black)
            .border(0.px)
            .borderRadius(5.px)
            .padding(left = 10.px, right = 20.px)
            .fontSize(16.px)
            .transition {
                property("border-color")
                duration(200.ms)
            }
    }

    hover{
        Modifier
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 6.px,
                spreadRadius = 3.px,
                color = rgba(0, 1, 6, 0.1)
            )
    }
}
val TextDescriptionFormStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(Colors.HalfWhite)
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .borderRadius(5.px)
            .fontSize(16.px)
            .color(Colors.Black)
            .styleModifier {
                property("overflow", "visible")
            }
            .transition {
                property("border-color")
                duration(200.ms)
            }
    }
    hover{
        Modifier
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 6.px,
                spreadRadius = 3.px,
                color = rgba(0, 1, 6, 0.1)
            )
    }
}